import React, { FC } from 'react';
import { DocumentNode } from '@apollo/client';
import QueryWithLoading from '../components/QueryWithLoading';
import { Typography, Grid, Divider } from '@mui/material';
import { WidgetPanel } from './WidgetPanel';

export const NumberWidget: FC<NumberWidgetProps> = ({ heading, icon, query, children }) => {
  return (
    <WidgetPanel>
      <Typography variant="h5">{heading}</Typography>
      <Grid container>
        <Grid style={{ paddingTop: 6 }} size={3}>
          {icon}
        </Grid>
        <Grid style={{ paddingTop: 10 }} size={9}>
          <Typography align="right" variant="h5" color="primary">
            <QueryWithLoading query={query}>{({ data: { number } }) => number}</QueryWithLoading>
          </Typography>
        </Grid>
      </Grid>
      <Divider />
      {children}
    </WidgetPanel>
  );
};

export interface NumberWidgetProps {
  heading: string;
  query: DocumentNode;
  icon: any;
  children?: React.ReactNode;
}
